export default {
  originCity: 'Select departure city',
  destinationCity: 'Select arrival city',
  direct: 'Direct',
  indirect: '1+ stops',
  getPrices: 'Get prices',
  directAvailable: 'Direct available from',
}
